<template>
  <div>
    <div class="flex flex-row justify-center gap-1">
      <Hand
        v-for="hand in dealerHands"
        :key="hand.id"
        v-bind:hand="hand"
        v-bind:type="'dealer'"
        class="mx-2 my-1 flex flex-row"
      />
    </div>
    <div class="flex justify-center mt-1">
      <div class="w-auto">
        <div class="bg-yellow text-black p-1 hadow-md rounded">
          (Totale: {{ dealerCardTotal }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import Card from "./Card";
import Hand from "./Hand";
export default {
  name: "Dealer",
  components: {
    Card,
    Hand
  },
  store,

  computed: {
    dealerCards() {
      return this.$store.getters.dealer.hands.reduce((acc, elem) => {
        acc.push(...elem.cards);
        return acc;
      }, []);
    },
    dealerHands() {
      return this.$store.getters.dealer.hands;
    },
    dealerCardTotal() {
      return this.$store.getters.dealer.hands.reduce((acc, elem) => {
        acc += elem.cardTotal;
        return acc;
      }, 0);
    },
    created() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dealer.vue